import React from 'react'
import { type HeaderProps } from './index.type'

export default React.memo<HeaderProps>(function Header({ leftChildren, centerChildren, rightChildren }) {
    return (
        <div className="flex items-center justify-between h-14 bg-white fixed top-0 left-0 right-0 z-2 px-6">
            {leftChildren || <div />}
            <div className="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 text-center">
                {centerChildren}
            </div>
            {rightChildren || <div />}
        </div>
    )
})